


function reset_point_orders(customerId){
  
  
  if(customerId == "" || customerId == null)
  {
    return;
  }
  
  $.ajax
    ({
      type		: "POST",
      url		: "//www.cconmausa.com/apps/extapi",
      cache		: false,
      dataType	: "json",
      async		: true,
      data		: {
        action :  "cancel_point_pay",
        customer_id : customerId
     },
      success		: function(jsonData)
      {
        _console_log("[RESPONSE] reset_point_orders");
        _console_log(jsonData);
        
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
          _console_log("Error code : " + XMLHttpRequest.status + "\n" +
              "message : " + textStatus.responseText + "\n" +
              "error : " + errorThrown);
      },
      complete : function ()
      {
          delete_expired_point_orders();
      }
    });
}

function delete_expired_point_orders(){

    $.ajax
    ({
        type		: "POST",
        url		: "//www.cconmausa.com/apps/extapi",
        cache		: false,
        dataType	: "json",
        async		: true,
        data		: {
            action :  "cancel_point_pays_with_completed_draftorder"
        },
        success		: function(jsonData)
        {
            _console_log("[RESPONSE] delete_expired_point_orders");
            _console_log(jsonData);

        },
        error		: function(XMLHttpRequest, textStatus, errorThrown)
        {
            _console_log("Error code : " + XMLHttpRequest.status + "\n" +
                "message : " + textStatus.responseText + "\n" +
                "error : " + errorThrown);
        }
    });
}